import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch, Link, Redirect } from "react-router-dom";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import GlobalApi from "../../Global/index";
import useDimensions from "../../Global/useDimensions";
import refresh_token from "../../Global/refresh_token";
import Drawer from "@material-ui/core/Drawer";
import Paper from "@material-ui/core/Paper";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from '@material-ui/core/Tooltip';

import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Colors from "../../Global/colors";
import LightButton from "../../Global/LightButton";
import Avatar from "@material-ui/core/Avatar";
import Container from "@material-ui/core/Container";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Email, Phone } from "@material-ui/icons";

import dashboard from "../../Assets/dashboard.png";
import template from "../../Assets/Template.png";
import inspection from "../../Assets/Inspection.png";
import schedule from "../../Assets/schedule.png";
import action from "../../Assets/action.png";
import InputLabel from '@material-ui/core/InputLabel';
import workflow from "../../Assets/workflow.png";
import analytics from "../../Assets/analytics.png";
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import notifications from "../../Assets/notifications.png";
import teamImg from "../../Assets/Team.png";
import logo from "../../Assets/Logo.png";
import help from "../../Assets/Help.png";
import up from "../../Assets/up.png";
import down from "../../Assets/down.png";
import userImg from "../../Assets/user.png";
import packageImg from "../../Assets/package.png";
import power from "../../Assets/power_off.png";
import Company_icon from "../../Assets/Company_icon.png";
import add_button from "../../Assets/add_button.png";
import team_top from "../../Assets/team_top.png";
import add_team from "../../Assets/add_team_2.png";
import swal from "@sweetalert/with-react";

//Redux
import { removeUser } from "../../Redux/Actions/userAction";
import {addCompany} from "../../Redux/Actions/companyAction"
import { removeCompany } from "../../Redux/Actions/companyAction";
import { addTeam } from "../../Redux/Actions/teamAction";
import { removeCompanyArr } from "../../Redux/Actions/companyArrActions";
import { removeIndustryArr } from "../../Redux/Actions/industryArrActions";

import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import i18next from 'i18next';
import Cookies from 'js-cookie'

import "./middleHeader.css";

import { useSelector, useDispatch } from "react-redux";
import { updateNotification } from "../../Redux/Actions/notificationAction";
import {setLanguage} from "../../Redux/Actions/languageAction"

const color1 = `rgb(85,206,199)`;
const color2 = `rgb(22,103,219)`;


const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      padding:'10px',
      backgroundColor:'#adcbf6'
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
  
    drawer: {
      width: "80px",
      flexShrink: 0,
      border: "none",
      borderTopLeftRadius:'50px',
      height:'96vh',
      overflow:'hidden'
  
    },
    drawerPaper: {
      width: "80px",
      backgroundColor: Colors.globalColor8,
      border: "none",
      height: '96vh',
      borderTopLeftRadius:'30px',
      borderBottomLeftRadius:'30px',
      margin:'10px',
      overflow:'hidden'
    },
    hide: {
      display: "none",
    },
    toolbar: theme.mixins.toolbar,
    
    drawerContainer: {
      backgroundColor: Colors.globalColor8,
      borderTopLeftRadius:'30px',
      borderBottomLeftRadius:'30px'
    },
    drawerHeader: {
      // display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: "flex-end",
    },
    content: {
      width:'100%',
      marginTop: 80,
      backgroundColor: "white",
      padding: theme.spacing(2),
      overflow: "scroll",
    },
    logoBox: {
      height: "150px",
      backgroundColor: "white",
    },
  
    listItem: {
      display: "flex",
      flexDirection: "column",
      height: "auto",
      justifyContent: "center",
      textAlign: "center",
      color: "white",
      width: "100px",
    },
    selector:{
      width:"200px",
      borderRadius:0,
      padding:5
    },
    large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      background: `linear-gradient(${100}deg,${color1}30%, ${color2})`,
    },
  }));

function MiddleHeader({disable}) {
  const currentLanguage = Cookies.get("i18next") || "en";
  const { t, i18n } = useTranslation();
  const [currentCompany, setCurrentCompany] = React.useState([]);
  const [companies, setCompanies] = React.useState([]);
  const [currentCompanyName, setCurrentCompanyName] = React.useState("");
  const [permissions_obj, setPermissionObj] = React.useState({});
  const [teams, setTeams] = React.useState([]);
  const [Token, setToken] = React.useState("");
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();


let data = useSelector((state) => state.companyArrReducer.company);
let company = useSelector((state) => state.companyReducer.company);
let userData = useSelector((state) => state.userReducer.user);
let language = useSelector((state) => state.languageReducer.language);

console.log("currentLanguage",currentLanguage)


useEffect(
  () => {
    if(data){
      setCompanies(data);
    }
  },
  [data]
);



useEffect(
  () => {
    getPermissions();
  },
  [company?.id]
);


const getPermissions = () => {
  console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
  let localstorage = localStorage.getItem("UserData");
  var data = JSON.parse(localstorage);
  let token = data?.token;
  if (data !== null) {
    let params = { company_id: company?.id, user_id: data?.user_id };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.msg === "success") {
          let permissionsObj = {};
          await response.data.map((v) => {
            permissionsObj[(v?.title)] = true;
          });
          console.log("Permissions Obj >>>>>>>", permissionsObj);

          setPermissionObj(permissionsObj);

        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "jwt malformed" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          // console.log(status);
          if (status) {
            // console.log("opopopop");
            getPermissions();
          }
        }
      })
      .catch((error) => {
        // localStorage.clear();
        // window.location.replace("/signin");
        console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
      });
  }
};

let data2 = useSelector((state) => state.companyReducer.company);
useEffect(
  () => {
    if(data2) {
      setCurrentCompany(data2);
      setCurrentCompanyName(data2.id)
      getTeamData(data2.id)
    }
  },[data2]);





const getTeamData = (company) =>{
  let localstorage = localStorage.getItem("UserData");
  var data = JSON.parse(localstorage);
  let tokenNew = data.token;


  let params = { company_id: company };
  
  let query = Object.keys(params)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    .join("&");

  fetch(GlobalApi + "/user/get_entity?" + query, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + tokenNew,
      "Content-Type": "application/json",
    },
  })
    .then((responseJson) => responseJson.json())
    .then(async (response) => {
      console.log("RESPONSE TEAM 8888888>>>>", response);
      if(response.status == "Success"){
      
      dispatch(addTeam(response));
      setTeams(response.data)
      }
    })
    .catch((error) => console.log(error.message));
}


const handleCompanyChange = (value) =>{
  console.log(value.target.value)
  const index = companies.findIndex(item => item.id === value.target.value);
  console.log(index)
  console.log("value",companies[index])
  console.log("TOKEN" ,Token)
  dispatch(addCompany(companies[index]));
  dispatch(updateNotification(companies[index].id));
  getTeamData(companies[index].id)
  setCurrentCompanyName(companies[index].id)
}

const handleLanguageChange = (value) =>{
  i18n.changeLanguage(value)
  dispatch(setLanguage(value));
}



    return <>
        {window.innerWidth > 700 && <Grid container justifyContent="space-between" alignItems="center" style={{ borderLeft: "1px solid #dadada",borderRight: "1px solid #dadada", justifyContent: "space-between", padding: "5px 30px", backgroundColor: "white", borderBottom: "1px solid #dadada" }}>
            <Grid item>
              {/* <p style={{ display: "inline", color: Colors.globalColor8, textTransform: "uppercase", fontSize: 14, fontWeight: "bold" }} className="UserName">
                      {"COMPANY"}
                    </p> */}
                    {/* <Button onClick={()=> currentLanguage !== 'ar' ? handleLanguageChange('ar') :  handleLanguageChange('en') }>
                      Click
                    </Button> */}
            </Grid>

            <Grid item>
              <Grid container spacing={2} alignItems="center" style={{ alignItems: "center" }}>
                <Grid item>
                  <Grid container alignItems="center" spacing={1}>
                    <img src={Company_icon} height={25} style={{ display: "inline" }} />
                    &nbsp;
                    <p style={{ display: "inline", color: Colors.globalColor8, textTransform: "uppercase", fontSize: 12, fontWeight: "bold" }} className="UserName">
                    <>{t('Company')}</>{" : "}
                    </p>
                  </Grid>
                </Grid>
                <Grid item>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select disabled={disable ? true : false} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" onChange={(value) => handleCompanyChange(value)} size="small" className={"companySelector"} style={{textAlign:language !== 'ar' ? "left" : "left"}} value={currentCompanyName}>
                      {companies.map((item, index) => {
                        return <MenuItem value={item.id}>
                            {item.company_name}
                          </MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                {(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Company Management"] == true) && <Grid item style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <Tooltip title={"Add Company"} aria-label="">
                      <img src={add_button} height={25} onClick={() => history.push("/company")} />
                    </Tooltip>
                  </Grid>}
              </Grid>
            </Grid>

            <Grid item>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <Grid container alignItems="center" spacing={1}>
                    <img src={team_top} height={25} style={{ display: "inline" }} />
                    &nbsp;
                    <p style={{ display: "inline", color: Colors.globalColor8, textTransform: "uppercase", fontSize: 12, fontWeight: "bold" }} className="UserName">
                      <>{t("My Team")}</>{" : "}
                    </p>
                  </Grid>
                </Grid>
                <Grid item>
                  <div style={{ cursor: "pointer", display: "flex", alignItems: "center", overflow: "hidden" }} onClick={() => history.push("/team")}>
                    <Tooltip title={"Add Team"} aria-label="">
                      <img src={add_team} height={30} style={{ display: "inline" }} />
                    </Tooltip>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {teams?.length > 0 && teams?.map((v, i) => {
                          if (i <= 3) {
                            return <Tooltip title={`${v?.first_name} ${v?.last_name}`} aria-label="">
                                {v.avatar !== null ? <div style={{ width: 30, height: 30, borderRadius: "50px", color: "#043077", display: "flex", boxShadow: " 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 12px 0 rgba(0, 0, 0, 0.19)", justifyContent: "center", margin: 1, alignItems: "center", backgroundImage: `url(https://server.uraudits.com/view?Key=${v.avatar})`, backgroundSize: "cover" }} /> : <div style={{ width: 30, height: 30, borderRadius: "50px", boxShadow: " 0 0.5px 1px 0 rgba(0, 0, 0, 0.2), 0 0.5px 12px 0 rgba(0, 0, 0, 0.19)", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                                    <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                                      {v?.first_name
                                        .substring(0, 1)
                                        .toUpperCase()
                                        .concat(v?.last_name
                                            .substring(0, 1)
                                            .toUpperCase())}
                                    </p>
                                  </div>}
                              </Tooltip>;
                          } else {
                            return <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                                <p>+{teams.length - 3}</p>
                              </div>;
                          }
                        })}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>}

        {window.innerWidth > 500 && window.innerWidth <= 700 && <Grid container justifyContent="center" alignItems="center" style={{ borderLeft: "1px solid #dadada",borderRight: "1px solid #dadada", justifyContent: "center", padding: "5px 30px", backgroundColor: "white", borderBottom: "1px solid #dadada" }}>
            <Grid item>
              <Grid container spacing={2} alignItems="center" style={{ alignItems: "center" }}>
                <Grid item>
                  <Grid container alignItems="center" spacing={1}>
                    <img src={Company_icon} height={30} style={{ display: "inline" }} />
                    &nbsp;
                    <p style={{ display: "inline", color: Colors.globalColor8, textTransform: "uppercase", fontSize: 12, fontWeight: "bold" }} className="UserName">
                    <>{t('Company')}</>{" : "}
                    </p>
                  </Grid>
                </Grid>
                <Grid item>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select disabled={disable ? true : false} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" onChange={(value) => handleCompanyChange(value)} style={{textAlign:language !== 'ar' ? "left" : "left"}} size="small" className={"companySelector"} value={currentCompanyName}>
                      {companies.map((item, index) => {
                        return <MenuItem value={item.id}>
                            {item.company_name}
                          </MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                {(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Company Management"] == true) && <Grid item style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <Tooltip title={"Add Company"} aria-label="">
                      <img src={add_button} height={25} onClick={() => history.push("/company")} />
                    </Tooltip>
                  </Grid>}
              </Grid>
            </Grid>
          </Grid>}

        {window.innerWidth <= 500 && <Grid container justifyContent="center" alignItems="center" style={{ borderLeft: "1px solid #dadada",borderRight: "1px solid #dadada", justifyContent: "space-between", padding: "10px", backgroundColor: "white", borderBottom: "1px solid #dadada" }}>
            <Grid item xs={12}>
              <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "center", alignItems: "center" }}>
                <img src={Company_icon} height={25} style={{ display: "inline" }} />
                &emsp;
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select disabled={disable ? true : false} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" onChange={(value) => handleCompanyChange(value)} size="small" style={{textAlign:language !== 'ar' ? "left" : "left"}} className={"companySelector"} value={currentCompanyName}>
                    {companies.map((item, index) => {
                      return <MenuItem value={item.id}>
                          {item.company_name}
                        </MenuItem>;
                    })}
                  </Select>
                </FormControl>
                &emsp;
                {(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Company Management"] == true) && <img src={add_button} height={25} onClick={() => history.push("/company")} />}
              </div>
            </Grid>
          </Grid>}
      </>;
}

export default MiddleHeader
